import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { AppStateService } from './app-state.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(
    private appState: AppStateService,
    private http: HttpClient,) { }

  isAuthenticated(): Promise<boolean> {
    return new Promise(resolve => {
      this.appState.getAuthResult.pipe(take(1)).subscribe(authResult => {
        // authenticated = await this.verifyToken(token).then(verifyd => (verifyd));
        if (authResult && authResult.accessToken) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    })
  }

  verifyToken(accessToken: string): Promise<boolean> {
    return this.http.put<boolean>(`${environment.base_url}${environment.endpoints.verifyToken}`, accessToken).toPromise();
  }
}
